import api from '../../helpers/axios'
export const state = {
    user: null,
    users: []
};

export const getters = {
    user: (state) => state.user,
    users: (state) => state.users
};

export const mutations = {
    setUser(state, newValue) {
        state.user = newValue;
    },
    setUsers(state, newValue) {
        state.users = newValue;
    },
};


export const actions = {
  /*  updateLmsUser(_, {id,data}) {
        return new Promise((resolve) => {
            api.put("/customer-users/"+id,data /!*data, {
                headers: {
                    "domain": data.site
                }
            }*!/).then((res) => {
                resolve(res.data.data)
            })
        });
    },
*/
    updateLmsUser(_, {id,data}) {
        return new Promise((resolve,reject) => {
            api.put("/customer-users/"+id, data).then((res) => {
                if(res){
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },

    deleteLmsUser(_, id) {
        return new Promise((resolve) => {
            api.delete("/customer-users/"+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },


    fetchLmsUser({ commit }, {  id }) {
        return new Promise((resolve, reject) => {
            api.get("/customer-users/" + id).then((res) => {
                commit("setUser", res.data.data);
                resolve(res.data.data);
            }).catch(err => {
                reject(err);
            });
        });
    },


    fetchLmsUsers({ commit }, {page, limit, search, listType}) {
        let query = "?";
        if(listType){
            query+=`listType=${listType}`
        }else{
            if (search) {
                query += `q=${search}&`;
            }
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }
        return new Promise((resolve) => {
            api.get("/customer-users"+query).then((res) => {
                commit("setUsers", res.data.data);
                resolve(res.data.data)
            })
        });
    }
};
